// extracted by mini-css-extract-plugin
export default {"container":"Projects_container__KtZIt","cardContainer":"Projects_cardContainer__NtYka","card":"Projects_card__NJwmC"};